import { Dispatch } from '~/types';

export default function ProfileActions(dispatch: Dispatch) {
  return {
    onLoadFeaturedSubjects({
      subjects,
      username
    }: {
      subjects: object[];
      username: string;
    }) {
      return dispatch({
        type: 'LOAD_FEATURED_SUBJECTS',
        subjects,
        username
      });
    },
    onLoadNotables({
      feeds,
      loadMoreButton,
      username
    }: {
      feeds: object[];
      loadMoreButton: boolean;
      username: string;
    }) {
      return dispatch({
        type: 'LOAD_NOTABLES',
        feeds,
        loadMoreButton,
        username
      });
    },
    onLoadPinnedAICards({
      cardIds,
      username
    }: {
      cardIds: number[];
      username: string;
    }) {
      return dispatch({
        type: 'LOAD_PINNED_AI_CARDS',
        cardIds,
        username
      });
    },
    onLoadPinnedBuilds({
      builds,
      favoriteViewerId,
      isTopBuilds,
      username
    }: {
      builds: object[];
      favoriteViewerId?: number;
      isTopBuilds?: boolean;
      username: string;
    }) {
      return dispatch({
        type: 'LOAD_PINNED_BUILDS',
        builds,
        favoriteViewerId,
        isTopBuilds,
        username
      });
    },
    onLoadMoreNotables({
      feeds,
      loadMoreButton,
      username
    }: {
      feeds: object[];
      loadMoreButton: boolean;
      username: string;
    }) {
      return dispatch({
        type: 'LOAD_MORE_NOTABLES',
        feeds,
        loadMoreButton,
        username
      });
    },
    onLoadPosts({
      feeds,
      loadMoreButton,
      section,
      username
    }: {
      feeds: object[];
      loadMoreButton: boolean;
      section: string;
      username: string;
    }) {
      return dispatch({
        type: 'LOAD_POSTS',
        feeds,
        loadMoreButton,
        section,
        username
      });
    },
    onLoadLikedPosts({
      feeds,
      loadMoreButton,
      section,
      username
    }: {
      feeds: object[];
      loadMoreButton: boolean;
      section: string;
      username: string;
    }) {
      return dispatch({
        type: 'LOAD_LIKED_POSTS',
        feeds,
        loadMoreButton,
        section,
        username
      });
    },
    onLoadPostsByUser({
      feeds,
      loadMoreButton,
      section,
      username
    }: {
      feeds: object[];
      loadMoreButton: boolean;
      section: string;
      username: string;
    }) {
      return dispatch({
        type: 'LOAD_POSTS_BY_USER',
        feeds,
        loadMoreButton,
        section,
        username
      });
    },
    onLoadMorePosts({
      feeds,
      loadMoreButton,
      section,
      username
    }: {
      feeds: object[];
      loadMoreButton: boolean;
      section: string;
      username: string;
    }) {
      return dispatch({
        type: 'LOAD_MORE_POSTS',
        feeds,
        loadMoreButton,
        section,
        username
      });
    },
    onLoadMoreLikedPosts({
      feeds,
      loadMoreButton,
      section,
      username
    }: {
      feeds: object[];
      loadMoreButton: boolean;
      section: string;
      username: string;
    }) {
      return dispatch({
        type: 'LOAD_MORE_LIKED_POSTS',
        feeds,
        loadMoreButton,
        section,
        username
      });
    },
    onLoadMorePostsByUser({
      feeds,
      loadMoreButton,
      section,
      username
    }: {
      feeds: object[];
      loadMoreButton: boolean;
      section: string;
      username: string;
    }) {
      return dispatch({
        type: 'LOAD_MORE_POSTS_BY_USER',
        feeds,
        loadMoreButton,
        section,
        username
      });
    },
    onResetProfile(username: string) {
      return dispatch({
        type: 'RESET_PROFILE',
        username
      });
    },
    onResetProfileViewerState() {
      return dispatch({
        type: 'RESET_PROFILE_VIEWER_STATE'
      });
    },
    onSetFeaturedSubjects({
      subjects,
      username
    }: {
      subjects: object[];
      username: string;
    }) {
      return dispatch({
        type: 'SET_FEATURED_SUBJECTS',
        subjects,
        username
      });
    },
    onSetPinnedAICards({
      cardIds,
      username
    }: {
      cardIds: number[];
      username: string;
    }) {
      return dispatch({
        type: 'SET_PINNED_AI_CARDS',
        cardIds,
        username
      });
    },
    onSetPinnedBuilds({
      builds,
      favoriteViewerId,
      isTopBuilds,
      username
    }: {
      builds: object[];
      favoriteViewerId?: number;
      isTopBuilds?: boolean;
      username: string;
    }) {
      return dispatch({
        type: 'SET_PINNED_BUILDS',
        builds,
        favoriteViewerId,
        isTopBuilds,
        username
      });
    },
    onSetPinnedBuildsExpanded({
      expanded,
      username
    }: {
      expanded: boolean;
      username: string;
    }) {
      return dispatch({
        type: 'SET_PINNED_BUILDS_EXPANDED',
        expanded,
        username
      });
    },
    onSetProfileId({
      username,
      profileId
    }: {
      username: string;
      profileId: number;
    }) {
      return dispatch({
        type: 'SET_PROFILE_ID',
        username,
        profileId
      });
    },
    onUserNotExist(username: string) {
      return dispatch({
        type: 'USER_NOT_EXIST',
        username
      });
    }
  };
}
